import _ConciergeService from "../services/concierge-service";
import { IConciergeService } from "../types/services/concierge-service";

const instance: IConciergeService = new _ConciergeService();

export default instance;
